import { IconPropsDeprecated } from '@umanforge/common';

export const ZipCodeIcon = ( { className, size, onClick }: IconPropsDeprecated ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 469.93945"
      className={ className }
      style={{ height: size, width: size }}
      onClick={ onClick }
    >
      <path d="m 48,85.939453 c -26.5,0 -48,21.499997 -48,47.999997 0,15.1 7.1,29.3 19.2,38.4 l 217.6,163.2 c 11.4,8.5 27,8.5 38.4,0 l 217.6,-163.2 c 12.1,-9.1 19.2,-23.3 19.2,-38.4 0,-26.5 -21.5,-47.999997 -48,-47.999997 z M 0,197.93945 v 208 c 0,35.3 28.7,64 64,64 h 384 c 35.3,0 64,-28.7 64,-64 v -208 l -217.6,163.2 c -22.8,17.1 -54,17.1 -76.8,0 z" />
      <circle
        style={{
          fill: '#ffffff',
          fillOpacity: 1,
          stroke: '#000000',
          strokeWidth: 16,
          strokeLinejoin: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'stroke markers fill'
        }}
        cx="254.22296"
        cy="126.28021"
        r="118.28021"
      />
      <text
        style={{
          fontStyle: 'normal',
          fontVariant: 'normal',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontSize: '65px',
          fontFamily: 'Arial Rounded MT Bold',
          whiteSpace: 'pre',
          inlineSize: 72.6682,
          fill: '#000000',
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: 56.3166,
          strokeLinejoin: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'stroke fill markers'
        }}
        transform="matrix(1.7212938,0,0,1.7212938,-180.39789,-95.553825)"
      >
        <tspan
          x="204"
          y="150"
        >
            ZIP
        </tspan>
      </text>
    </svg>
  );
};